// extracted by css-extract-rspack-plugin
export default {"negativeTopMargin":"_4a480ced"};